<template>
  <v-dialog v-model="isDialogOpen" width="auto">
    <v-card>
      <v-card-title>{{ $t('pushNotifications.dialogTitle') }}</v-card-title>
      <v-card-text>
        {{ $t('pushNotifications.dialogBody') }}
      </v-card-text>
      <v-card-actions class="ga-5">
        <v-spacer />
        <v-btn-neutral rounded @click="declineNotifications">
          {{ $t('pushNotifications.decline') }}
        </v-btn-neutral>
        <v-btn-primary data-testid="push-notifications-accept" @click="subscribeToNotifications">
          {{ $t('pushNotifications.accept') }}
        </v-btn-primary>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { urlBase64ToUint8Array } from '@/helpers/util';
import { useCustomerStore } from '@/store/customer';
import { useNotificationStore } from '@/store/notifications';
import { useUserStore } from '@/store/user';

const { getNotifications, addNotification, notificationAction } = useNotificationStore();

const customerStore = useCustomerStore();
const userStore = useUserStore();

let isDialogOpen = ref(false);

const registerPushNotifications = async () => {
  if (customerStore.arePushNotificationsDeclined()) {
    return;
  }

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    isDialogOpen.value = true;
  }

  addPostMessageListener();
};

const declineNotifications = () => {
  isDialogOpen.value = false;
  customerStore.declinePushNotifications();
};

const subscribeToNotifications = async () => {
  isDialogOpen.value = false;

  const vapidPublicKey = import.meta.env.VITE_VAPID_PUBLIC_KEY;
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
    });

    customerStore
      .registerSubscription(subscription)
      .catch(console.error);
  } catch (e) {
    console.warn('Unable to register subscription.', e);
  }
};

const addPostMessageListener = () => {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data.event === 'push') {
      addNotification(event.data.payload);
    } else if (event.data.event === 'click') {
      notificationAction(event.data.payload);
    }
  });
};

if (userStore.userLoggedIn) {
  getNotifications();
}
if (!navigator.webdriver) {
  registerPushNotifications();
}
</script>
